

export class Model_ForexCRM_LocationServed

    {      
  
            public LocationServedId : number;
            public LocationName   :string;
                   
    }       